export const StatusCodes = {
    MOVED_PERMANENTLY: '301',
    FOUND: '302',
    PERMANENT_REDIRECT: '308',
    NOT_FOUND: '404',
    GONE: '410'
};

export const StatusCodeOptions = [
    { label: '301 Moved Permanently', value: StatusCodes.MOVED_PERMANENTLY },
    { label: '302 Found', value: StatusCodes.FOUND },
    { label: '308 Permanent Redirect', value: StatusCodes.PERMANENT_REDIRECT },
    { label: '404 Not Found', value: StatusCodes.NOT_FOUND },
    { label: '410 Gone', value: StatusCodes.GONE }
];

export const StatusCodesToRequired = [
    StatusCodes.MOVED_PERMANENTLY,
    StatusCodes.FOUND,
    StatusCodes.PERMANENT_REDIRECT
];
